export class DeviceInfos {
    userId              : string;
    deviceUUID          : string;
    firebaseToken       : string;
    deviceType          : string;
    deviceModel         : string;
    env                 : number;
    version             : string;
    updateAt            : Date;
}